export enum EPageType {
  Authorization = 'authorization',
  Registration = 'registration',
  NewPassword = 'newPassword',
  SocialLogin = 'socialLogin',
}
